function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import { composeEnhancers } from "../helpers";
import createStyledEnhancer from "../helpers/createStyledEnhancer";

var transformationXY = function transformationXY(name, axis) {
  var isX = axis === "x";
  return function (value) {
    var _ref;

    var stringValue = typeof value === "number" ? "".concat(value, "px") : "".concat(value);
    return _ref = {}, _defineProperty(_ref, "".concat(name).concat(isX ? "Left" : "Top"), stringValue), _defineProperty(_ref, "".concat(name).concat(isX ? "Right" : "Bottom"), stringValue), _ref;
  };
};

export var margin = createStyledEnhancer({
  name: "margin",
  alias: ["m"]
});
export var marginTop = createStyledEnhancer({
  name: "marginTop",
  alias: ["mt"]
});
export var marginBottom = createStyledEnhancer({
  name: "marginBottom",
  alias: ["mb"]
});
export var marginLeft = createStyledEnhancer({
  name: "marginLeft",
  alias: ["ml"]
});
export var marginRight = createStyledEnhancer({
  name: "marginRight",
  alias: ["mr"]
});
export var marginX = createStyledEnhancer({
  name: "marginX",
  directTransformation: true,
  transformation: transformationXY("margin", "x"),
  alias: ["mx"]
});
export var marginY = createStyledEnhancer({
  name: "marginY",
  directTransformation: true,
  transformation: transformationXY("margin", "y"),
  alias: ["my"]
});
export var padding = createStyledEnhancer({
  name: "padding",
  alias: ["p"]
});
export var paddingTop = createStyledEnhancer({
  name: "paddingTop",
  alias: ["pt"]
});
export var paddingBottom = createStyledEnhancer({
  name: "paddingBottom",
  alias: ["pb"]
});
export var paddingLeft = createStyledEnhancer({
  name: "paddingLeft",
  alias: ["pl"]
});
export var paddingRight = createStyledEnhancer({
  name: "paddingRight",
  alias: ["pr"]
});
export var paddingX = createStyledEnhancer({
  name: "paddingX",
  directTransformation: true,
  transformation: transformationXY("padding", "x"),
  alias: ["px"]
});
export var paddingY = createStyledEnhancer({
  name: "paddingY",
  directTransformation: true,
  transformation: transformationXY("padding", "y"),
  alias: ["py"]
});
export var margins = composeEnhancers(margin, marginTop, marginBottom, marginLeft, marginRight, marginX, marginY);
export var paddings = composeEnhancers(padding, paddingTop, paddingBottom, paddingLeft, paddingRight, paddingX, paddingY);

var calculateGap = function calculateGap(gap) {
  var _String$split = String(gap).split(/(\d*\.\d+|\d+),?/g),
      _String$split2 = _slicedToArray(_String$split, 3),
      number = _String$split2[1],
      unit = _String$split2[2];

  return {
    value: Math.abs(Number.parseInt(number, 10) / 2),
    unit: unit || "px"
  };
};

export var getGapProperties = function getGapProperties(gap) {
  var gapPadding = "0";
  var gapMargin = "0"; // 2 if чтобы правильно работал type guard

  if (typeof gap === "string") {
    gap = [gap, gap];
  }

  if (typeof gap === "number") {
    gap = [gap, gap];
  }

  if (Array.isArray(gap)) {
    var _gap = gap,
        _gap2 = _slicedToArray(_gap, 2),
        _gap2$ = _gap2[0],
        y = _gap2$ === void 0 ? "0" : _gap2$,
        x = _gap2[1];

    var _calculateGap = calculateGap(y),
        yValue = _calculateGap.value,
        yUnit = _calculateGap.unit;

    var _calculateGap2 = calculateGap(x !== null && x !== void 0 ? x : y),
        xValue = _calculateGap2.value,
        xUnit = _calculateGap2.unit;

    gapPadding = "".concat(yValue).concat(yUnit, " ").concat(xValue).concat(xUnit);
    gapMargin = "".concat(-yValue).concat(yUnit, " ").concat(-xValue).concat(xUnit);
  }

  return {
    padding: gapPadding,
    margin: gapMargin
  };
};

var gapTransformation = function gapTransformation(property) {
  var _getGapProperties = getGapProperties(property),
      gapPadding = _getGapProperties.padding,
      gapMargin = _getGapProperties.margin;

  return {
    // Если колонка является строкой (col={true} row={true}), то убираем margin
    margin: gapMargin,
    "& > *": {
      padding: gapPadding
    }
  };
};

var gap = createStyledEnhancer({
  name: "gap",
  directTransformation: true,
  transformation: gapTransformation
});
export var spacing = composeEnhancers(margins, paddings, gap);
export var spacingWithoutGap = composeEnhancers(margins, paddings);